<template>
  <highcharts :options="options" />
</template>

<script>
import Highcharts from 'highcharts'
import { Chart } from 'highcharts-vue'

export default {
  name: 'HighchartsFormattingWrapper',
  components: {
    highcharts: Chart
  },
  props: {
    chartOptions: { type: Object, default: () => ({}) }
  },
  computed: {
    options () {
      return Highcharts.merge(defaultHighchartsSettings, this.chartOptions)
    }
  }
}

const defaultHighchartsSettings = {
  credits: {
    enabled: false
  },
  chart: {
    backgroundColor: 'transparent',
    renderTo: null
  },
  exporting: {
    buttons: {
      printButton: {
        enabled: false
      },
      exportButton: {
        enabled: false
      },
      contextButton: {
        enabled: false
      }
    }
  },
  title: {
    text: null
  },
  tooltip: {
    shared: false,
    useHTML: true,
    style: {
      fontWeight: 'bold'
    },
    shape: 'callout',
    headerFormat: '<small>{point.key}</small><table>',
    pointFormat: '<tr><td style="color: #222">{series.name}: </td>' +
      '<td style="text-align: right"><b>{point.y}</b></td></tr>',
    footerFormat: '</table>',
    nullFormat: 'No data',
    valuePrefix: ' ',
    valueDecimals: 0,
    valueSuffix: ' {point.sfx}',
    split: false
  },
  series: [],
  xAxis: {
    tickInterval: 24 * 3600 * 1000,
    lineWidth: 0,
    tickWidth: 0,
    startOnTick: false,
    endOnTick: false,
    gridLineWidth: 0,
    title: {},
    dateTimeLabelFormats: {
      day: '%m.%d.',
      week: '%m.%d.',
      month: '%m.%d.',
      year: '%m.%d.'
    },
    labels: {
      align: 'center'
    },
    showFirstLabel: true,
    showLastLabel: true,
    type: 'datetime'
  },
  plotOptions: {
    turboThreshold: 2000,
    bar: {
      turboThreshold: 2000,
      cursor: 'pointer'
    },
    column: {
      turboThreshold: 2000,
      cursor: 'pointer'
    },
    networkgraph: {
      turboThreshold: 2000,
      cursor: 'pointer'
    },
    heatmap: {
      turboThreshold: 2000,
      cursor: 'pointer'
    },
    series: {
      turboThreshold: 2000,
      cursor: 'pointer',
      marker: {
        symbol: 'circle',
        enabled: false
      }
    },
    line: {
      turboThreshold: 2000,
      cursor: 'pointer',
      marker: {
        symbol: 'circle',
        enabled: false
      }
    },
    spline: {
      turboThreshold: 2000,
      cursor: 'pointer',
      marker: {
        symbol: 'circle',
        enabled: false
      }
    },
    arearange: {
      turboThreshold: 2000,
      cursor: 'pointer',
      marker: {
        symbol: 'circle',
        enabled: false
      },
      states: {
        hover: {
          enabled: false
        }
      },
      lineWidth: 0
    }
  },
  yAxis: {
    lineWidth: 0,
    tickWidth: 0,
    startOnTick: false,
    endOnTick: false,
    gridLineWidth: 1,
    title: {
      text: ''
    },
    dateTimeLabelFormats: {
      day: '%m.%d.',
      week: '%m.%d.',
      month: '%m.%d.',
      year: '%m.%d.'
    },
    plotBands: [{
      from: -1000000,
      to: 0,
      color: 'rgba(255, 106, 106, 0.1)'
    }],
    labels: {
      align: 'center'
    },
    showFirstLabel: true,
    showLastLabel: true
  },
  legend: {
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'horizontal',
    x: 0,
    y: 0
  }
}
</script>
